
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/collections/[slug]/gallery",
      function () {
        return require("private-next-pages/collections/[slug]/gallery.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/collections/[slug]/gallery"])
      });
    }
  